import { render, staticRenderFns } from "./ward.vue?vue&type=template&id=03101f62&scoped=true&"
import script from "./ward.vue?vue&type=script&lang=js&"
export * from "./ward.vue?vue&type=script&lang=js&"
import style0 from "./ward.vue?vue&type=style&index=0&id=03101f62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03101f62",
  null
  
)

export default component.exports